<app-filter-menu-skeleton
    [secondaryActionButton]="{
        icon: ['fas', 'plus'],
        label: 'create',
        type: ButtonType.SECONDARY,
    }"
    [secondaryActionDisabled]="!mapFilterPermissionsService.canManage()"
    [secondaryActionTooltip]="
        !mapFilterPermissionsService.canManage() ? ('insufficientPermissions' | transloco) : undefined
    "
    (secondaryButtonClicked)="createFilter()"
    (submit)="submit()">
    <h2 class="!font-medium !text-base px-2 pt-2">{{ 'mapFilter.filterCombination' | transloco }}</h2>
    @if (isEditMode()) {
        <app-edit-warn-message displayedMessage="editMode.filterNotApplyToCurrentEdit" />
    }

    <div class="!py-2 !px-2">
        @if (mapFilterService.filters().length) {
            <app-custom-search
                [isNarrowSearchBar]="true"
                (resetSearch)="filterSearch.set('')"
                (search)="filterSearch.set($event)" />

            <h3 class="!font-normal !text-subtitle-1 !mb-0 !mt-1">{{ 'mapFilter.yourCombination' | transloco }}</h3>
            <ol class="list-none pl-0 mb-2 mt-1">
                @for (filter of checkedFilters(); track filter.id) {
                    <app-map-filter-item
                        [checkboxState]="CheckboxState.CHECKED"
                        [filter]="filter"
                        (deleteFilter)="deleteFilter($event)"
                        (editFilter)="editFilter($event)"
                        (toggleFilterSelection)="toggleFilterSelection($event)" />
                    @if ($count > 1 && filter !== checkedFilters().at(-1)) {
                        <span class="text-primary text-overline"> {{ 'and' | transloco | uppercase }} </span>
                    }
                } @empty {
                    <span class="text-custom-dark-grey text-body-2 select-none">
                        {{ 'mapFilter.noActiveFilter' | transloco }}
                    </span>
                }
            </ol>

            <h3 class="!font-normal !text-subtitle-1 pt-3 !mb-0">{{ 'mapFilter.yourFilters' | transloco }}</h3>
            <ol class="list-none pl-0 !mt-1">
                @for (filter of inactiveFilters(); track filter.id) {
                    <app-map-filter-item
                        [checkboxState]="CheckboxState.UNCHECKED"
                        [filter]="filter"
                        (deleteFilter)="deleteFilter($event)"
                        (editFilter)="editFilter($event)"
                        (toggleFilterSelection)="toggleFilterSelection($event)" />
                } @empty {
                    <span class="text-custom-dark-grey text-body-2 select-none">
                        {{ 'mapFilter.noInactiveFilter' | transloco }}
                    </span>
                }
            </ol>
        } @else {
            <p class="pt-6">{{ 'mapFilter.noFilterForProject' | transloco }}</p>
        }
    </div>
</app-filter-menu-skeleton>
